import { PublicClientApplication, type Configuration, LogLevel } from "@azure/msal-browser";
import { VITE_ENTRA_CLIENT_ID, VITE_ENTRA_TENANT_ID } from "../config/env";

const msalConfiguration: Configuration = {
  auth: {
    clientId: VITE_ENTRA_CLIENT_ID,
    authority: `https://login.microsoftonline.com/${VITE_ENTRA_TENANT_ID}`,
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "localStorage",
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            break;
          case LogLevel.Warning:
            console.warn(message);
            break;
          default:
            break;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

export const msalInstance = new PublicClientApplication(msalConfiguration);

// MSAL v3+ requires explicit initialization before use
export const msalInitPromise = msalInstance.initialize();

export const loginRequest = {
  scopes: ["openid", "profile", "email"],
};
